var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTarget = function SvgTarget(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 12.4183 12.4183 16 8 16ZM9 2.091V4C9 4.55228 8.55229 5 8 5C7.44772 5 7 4.55228 7 4V2.091C4.48818 2.51737 2.52176 4.4874 2.1 7H4C4.55228 7 5 7.44772 5 8C5 8.55229 4.55228 9 4 9H2.1C2.52176 11.5126 4.48818 13.4826 7 13.909V12C7 11.4477 7.44772 11 8 11C8.55229 11 9 11.4477 9 12V13.909C11.5118 13.4826 13.4782 11.5126 13.9 9H12C11.4477 9 11 8.55229 11 8C11 7.44772 11.4477 7 12 7H13.9C13.4782 4.4874 11.5118 2.51737 9 2.091Z"
  })));
};
export default SvgTarget;